import { Form, Select } from 'antd';

const { Option } = Select;

export const ContactCodeSelector = (
  <Form.Item name="contact_code" noStyle>
    <Select className="select-code" defaultValue="91">
      <Option value="91">+91</Option>
      <Option value="61">+61</Option>
    </Select>
  </Form.Item>
);
